import { useMemo } from "react"

export const useWorldMaps = (countries, regions) => {
  return useMemo(() => {
    const countryToRegion = {}
    const availableCountries = {}
    const countryInfo = {}
    const regionsMap = {}

    regions.forEach((r) => {
      regionsMap[r.code] = {
        name: r.name,
        color: r.color,
        description: r.description,
        center: [r.center_lng, r.center_lat],
        zoom: r.zoom,
      }
    })

    countries.forEach((c) => {
      const regionCode = c.region.code

      countryToRegion[c.code] = regionCode

      if (!availableCountries[regionCode]) {
        availableCountries[regionCode] = []
      }

      availableCountries[regionCode].push(c.code)

      countryInfo[c.code] = {
        name: c.name,
        description: c.description,
      }
    })

    return {
      countryToRegion,
      availableCountries,
      countryInfo,
      regionsMap,
    }
  }, [countries, regions])
}